import { api } from '@/utils/api';
import { Parameter } from './Parameter';
import { sanitizePathParam } from '@/utils/sanitize';
import { ParameterForecast } from '../ParameterForescat/ParameterForecast';

export default class ParameterRepository {
  //Get Params with Sources
  async getParametersByInfraestructure(
    infraestructureId: string,
  ): Promise<Parameter[]> {
    const iid = sanitizePathParam(infraestructureId);
    const parameters = await api.get(
      `/measurements/infrastructures/${iid}/parameters/all/sources/all`,
    );
    return parameters.data;
  }

  // Only Id an Name
  async getParametersListByInfrastructure(
    infraestructureId: number,
  ): Promise<Parameter[]> {
    const iid = sanitizePathParam(infraestructureId);
    const parameters = await api.get(
      `/measurements/infrastructure/${iid}/params/all`,
    );
    return parameters.data;
  }

  async deleteParameter(parameterId: any): Promise<boolean> {
    const pid = sanitizePathParam(parameterId);
    const result = await api.delete(`/measurements/parameters/${pid}`);
    return result.data;
  }

  async changeVisibleParameter(
    parameterId: any,
    visible: boolean,
  ): Promise<boolean> {
    const pid = sanitizePathParam(parameterId);
    const result = await api.put(
      `/measurements/parameters/${pid}/visible?visible=${visible}`,
    );
    return result.data;
  }

  async postParameterForecast(
    parameterId: string | number,
    forecast: ParameterForecast,
  ): Promise<boolean> {
    const pid = sanitizePathParam(parameterId);
    const locations = await api.post(
      `measurements/parameters/${pid}/forecast/configuration`,
      forecast,
    );
    return locations.data.success === 1 || locations.data.success === 200;
  }
  async postParameterPastForecast(
    parameterId: string | number,
    forecast: ParameterForecast
  ): Promise<boolean> {
    const pid = sanitizePathParam(parameterId);
    const locations = await api.post(
      `measurements/parameters/${pid}/forecast/configuration`,
      forecast
    );
    return locations.data.success === 1;
  }

  async changeInUseParameter(
    infrastructureId: any,
    inUse: boolean,
  ): Promise<boolean> {
    const iid = sanitizePathParam(infrastructureId);
    const result = await api.put(
      `/measurements/infrastructures/${iid}?inUse=${inUse}`,
    );
    return result.data;
  }

  async changeShowInDashboardInfrastructure(
    infrastructureId: any,
    showInDashboard: boolean,
    inUse: boolean,
  ): Promise<boolean> {
    const iid = sanitizePathParam(infrastructureId);
    const result = await api.put(
      `/measurements/infrastructures/${iid}?inUse=${inUse}&showInDashboard=${showInDashboard}`,
    );
    return result.data;
  }

  async getInfraestructureInUse(
    location: string,
    page: string,
    size: string,
  ): Promise<Parameter[]> {
    debugger;
    if (location) {
      const loc = sanitizePathParam(location);
      const parameters = await api.get(
        `/measurements/location/${loc}/inuse?page=${page}&size=${size}`,
      );
      return parameters.data;
    } else {
      return [];
    }
  }

  async putFavoriteParameter(parameterId: string | number) {
    const pid = sanitizePathParam(parameterId);
    const parameters = await api.put(
      `/measurements/parameters/${pid}/principal`,
    );
    return parameters.data;
  }

  async getParameter(parameterId: string | number): Promise<Parameter[]> {
    const pid = sanitizePathParam(parameterId);
    const parameters = await api.get(`/measurements/parameters/${pid}`);
    return parameters.data;
  }
}
